import { render, staticRenderFns } from "./prices-row-new.vue?vue&type=template&id=4ef9cd14&"
import script from "./prices-row-new.vue?vue&type=script&lang=js&"
export * from "./prices-row-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports